import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogActions } from '@angular/material/dialog';
import { Applications } from 'src/app/interfaces/application';
import { ApplicationsService } from '../applications.service';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/list';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'mic-app-applications-delete',
  templateUrl: './applications-delete.component.html',
  styleUrls: ['./applications-delete.component.scss'],
  imports: [MatDialogTitle, MatIcon, MatDivider, MatDialogActions, MatButton]
})
export class ApplicationsDeleteComponent {
  dialogRef = inject<MatDialogRef<ApplicationsDeleteComponent>>(MatDialogRef);
  data = inject<Applications>(MAT_DIALOG_DATA);
  private readonly applicationService = inject(ApplicationsService);

  deletedApp: boolean;

  onNoClick() {
    this.deletedApp = false;
    this.dialogRef.close(this.deletedApp);
  }
  onRemove() {
    this.applicationService.removeById(this.data.id).subscribe(() => {});
    this.deletedApp = true;
    this.dialogRef.close(this.deletedApp);
  }
}
